var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._l(_vm.breadcrumbItems, function (breadcrumbItem) {
    return _c('b-breadcrumb-item', {
      key: breadcrumbItem.name,
      attrs: {
        "to": breadcrumbItem.to,
        "active": !!breadcrumbItem.active
      }
    }, [_vm._v(" " + _vm._s(breadcrumbItem.name) + " ")]);
  }), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 2)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _vm.title == '部門客戶' ? _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('AppSingleSelect', {
    staticClass: "w-100",
    attrs: {
      "id": "staff-customer-branch-select",
      "options": _vm.myBranchesOptions,
      "disabled": _vm.changingBranch,
      "placeholder": "-- 選擇部門 --"
    },
    on: {
      "input": _vm.handleChangeSelectedBranch
    },
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  })], 1), _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.staffOptions,
      "disabled": _vm.changingStaff
    },
    on: {
      "change": _vm.handleChangeSelectedStaff
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("-- 全部帳號 --")])];
      },
      proxy: true
    }], null, false, 1342189426),
    model: {
      value: _vm.selectedStaff,
      callback: function callback($$v) {
        _vm.selectedStaff = $$v;
      },
      expression: "selectedStaff"
    }
  })], 1), _c('div', {
    staticClass: "col-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.searchCustomer
    }
  }, [_vm._v(" 查詢 ")])], 1)]) : _vm._e(), _c('b-card-body', {
    staticClass: "p-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.staffNameLabel) + ": " + _vm._s(_vm.staff.name))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.staffIdLabel) + ": " + _vm._s(_vm.staff.employee_code))]), _c('br')])]), _c('hr'), _c('div', {
    staticClass: "row mb-1 align-items-center"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("客戶清單")])]), _c('div', {
    staticClass: "col-6 d-flex justify-content-end"
  }, [_c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    staticClass: "mr-2",
    attrs: {
      "staff": _vm.staff,
      "show-btn": _vm.showStaffAddCustomer
    },
    on: {
      "bind": _vm.bindCustomer
    }
  }), _vm.showBindAllCustomer ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.bindAllCustomers
    }
  }, [_c('i', {
    staticClass: "mdi mdi-account-multiple-plus mr-1"
  }), _vm._v("立即綁定所有會員 ")]) : _vm._e()], 1)]), _c('customer-staff-operator', {
    staticClass: "mb-3",
    attrs: {
      "filter": _vm.filter,
      "operator": _vm.operator,
      "boundTypes": _vm.boundTypes,
      "textMapping": _vm.textMapping
    },
    on: {
      "trigger-filter": function triggerFilter($event) {
        return _vm.fetchCustomers();
      },
      "trigger-change-staff": function triggerChangeStaff($event) {
        return _vm.showChangeStaff();
      },
      "trigger-unbind": function triggerUnbind($event) {
        return _vm.showUnbindStaff();
      },
      "trigger-change-bound-type": function triggerChangeBoundType($event) {
        return _vm.showChangeBoundType();
      }
    }
  }), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customers,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "head(id)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          on: {
            "change": _vm.handleSelectAll
          },
          model: {
            value: _vm.isSelectAll,
            callback: function callback($$v) {
              _vm.isSelectAll = $$v;
            },
            expression: "isSelectAll"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(id)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": data.item.pivot.id,
            "disabled": !_vm.filter.doesBound
          },
          on: {
            "change": _vm.handleChecboxChange
          },
          model: {
            value: _vm.selectedPivotIds,
            callback: function callback($$v) {
              _vm.selectedPivotIds = $$v;
            },
            expression: "selectedPivotIds"
          }
        })];
      }
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center",
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.goToCustomer(data.item);
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)])];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex",
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('a', {
          staticClass: "s-text-primary",
          on: {
            "click": function click($event) {
              return _vm.goToCustomer(data.item);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.hiddenString(data.item.name, 20)) + " ")])])];
      }
    }, {
      key: "cell(bound_type)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.mapBoundTypeName(data.item.bound_type)) + " ")];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  }), _c('div', {
    staticClass: "row"
  }, [_vm.$route.name != 'MyConsoleStaffCustomerList' ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回")])], 1)]) : _vm._e()])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }